var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      staticClass: "x-radio-button-large",
      attrs: {
        type: "radio",
        name: _vm.name,
        id: _vm.value,
        disabled: _vm.disabled
      },
      domProps: { checked: _vm.checked, value: _vm.value },
      on: { input: _vm.input }
    }),
    _vm._v(" "),
    _c(
      "label",
      {
        class: [
          "x-radio-button-large-label",
          { "x-radio-button-large-disabled": _vm.disabled }
        ],
        attrs: { for: _vm.value }
      },
      [
        _vm.checked
          ? _c("div", { staticClass: "tick-filled" }, [_c("ic-tick-filled")], 1)
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "wizard-radio-content" }, [
          _c(
            "div",
            { staticClass: "wizard-radio-content-text-icon" },
            [_vm._t("icon")],
            2
          ),
          _vm._v(" "),
          _c("div", [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }